export interface Assessment {
  id: string;
  name: string;
  description?: string;
  type: AssessmentType;
  isRequired: boolean;
  isActive: boolean;
  priority: number;
}

export interface CreateAssessment {
  name: string;
  description?: string;
  type: AssessmentType;
  isRequired: boolean;
  isActive: boolean;
  priority: number;
}

export interface UpdateAssessment {
  id: string;
  name: string;
  description?: string;
  type: AssessmentType;
  isRequired: boolean;
  isActive: boolean;
  priority: number;
}

export enum AssessmentType {
  Automatic = 1,
  Manual = 2,
}
